// extracted by mini-css-extract-plugin
export default {"filtering":"Filter_filtering__hap8J"};